import { render, staticRenderFns } from "./CallBackModal.vue?vue&type=template&id=55b1aa3e&scoped=true&"
import script from "./CallBackModal.vue?vue&type=script&lang=js&"
export * from "./CallBackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1aa3e",
  null
  
)

export default component.exports